import { render } from "./Markups.vue?vue&type=template&id=4667554f&scoped=true"
import script from "./Markups.vue?vue&type=script&lang=js"
export * from "./Markups.vue?vue&type=script&lang=js"

import "./Markups.vue?vue&type=style&index=0&id=4667554f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4667554f"]])

export default __exports__